import _ from "lodash";
import {addEditDPSourceActionTypes} from "../constants/AddEditActionConstants";

const initialState = {
    addNewDPSource: false,
    editDPSource: false,
    modalOpenDPSource: false,
    editModalOpenDPSource: false,
    updatedDPSource: false,
    dpSourceModalHeader: "",
    editVerifiableInputsValue: null,
    verifiableInputsIndex: null,
    dpSourceInputs: [],
    resultsArray: [],
    inputsArray: [],
    showVerifiableInputsOptions: false,
    toDelete: {
        verifiable_inputs: []
    },
    sourceObject: {
        approvals: {
            id: "",
            resource_id: "",
            is_approved: false,
            approved_on: null,
            approved_by: ""
        },
        country:{
            id: "",
            country_iso: "",
            country_name: "",
            kyc_status: "",
            kyc_tier: null,
            number_2x2_support: false,
            age_support: false,
            number_1x1_match_rate: null,
            number_2x2_match_rate: null,
            last_updated: ""
        },
        notes: [
            {
                note: "",
                notes_id: null,
                resource_id: "",
                type: "Internal"
            },
            {
                note: "",
                notes_id: null,
                resource_id: "",
                type: "External"
            },
        ],
        provider:{
            provider_id: "",
            provider_name: "",
            monthly_aggregate_volume: null,
            last_updated: "",
            created_date: "",
            is_deleted: false
        },
        service:{
            service_id: "",
            service_name: "",
            billing_group_id: "",
            last_updated: "",
            created_date: "",
            is_deleted: false,
            integration_status: false,
            provider: ""
        },
        source_detail:{
            source_id: "",
            source_type: null,
            source_type_identifier: "",
            source_type_description:"",
            overall_coverage: null,
            coverage_type: null,
            data_refresh_frequency: null,
            consent_required: false,
            consent_flag_required: false,
            contractual_passthrough: false,
            flag_required_sample: null,
            passthrough_sample: null,
            service_id: "",
            country: "",
            status: "",
            created_date: "",
            is_deleted: false,
            last_updated: "",
            resource_url: ""
        },
        verifiable_inputs: [],
    },
}


const addEditDPSourcesReducer = (state = initialState, action) => {
    switch (action.type) {

        case addEditDPSourceActionTypes.CREATE_DP_SOURCE_MODAL: {
            let newState = _.cloneDeep(state);
            newState.addNewDPSource = true;
            newState.modalOpenDPSource = true;
            newState.dpSourceModalHeader = "Add a new DP Source";
            return newState;
        }

        case addEditDPSourceActionTypes.EDIT_DP_SOURCE_MODAL: {
            let newState = _.cloneDeep(state);
            newState.editDPSource = true;
            newState.editModalOpenDPSource = true;
            newState.sourceObject = action.payload.detailObject;
            newState.dpSourceModalHeader = `Edit DP Source `
                + newState.sourceObject.source_detail.source_type + ` - ` +
                + newState.sourceObject.source_detail.source_type_identifier
                + ` In ` + newState.sourceObject.country.country_name;
            return newState;
        }

        case addEditDPSourceActionTypes.SETTING_DPSOURCE_FORM_OBJECT_VALUE: {
            let newState = _.cloneDeep(state);
            newState.sourceObject[action.payload.name] = action.payload.value;
            return newState;
        }

        case addEditDPSourceActionTypes.TOGGLE_RESULT_OPTION: {
            let newState = _.cloneDeep(state);
            let temp = [...newState.resultsArray];
            temp[action.payload.index][action.payload.field] = !temp[action.payload.index][action.payload.field];
            newState.resultsArray = temp;
            return newState;
        }

        case addEditDPSourceActionTypes.SETTING_SOURCE_TYPE_OPTION: {
            let newState = _.cloneDeep(state);
            if ( action.payload.source_type != null ) {
                newState.sourceObject.source_type = action.payload.source_type.label;
                newState.sourceObject.source_type_id = action.payload.source_type.id;
            } else {
                newState.sourceObject.source_type = "";
                newState.sourceObject.source_type_id = "";
            }
            return newState;
        }

        case addEditDPSourceActionTypes.UPDATED_DP_SOURCE_REFRESH: {
            let newState = _.cloneDeep(state);
            newState.updatedDPSource = !newState.updatedDPSource;
            return newState;
        }

        case addEditDPSourceActionTypes.CLOSE_DP_SOURCE_MODAL: {
           return initialState;
        }

        case "UPDATE_SOURCE_DETAIL": {
            let newState = _.cloneDeep(state);
            newState.sourceObject.source_detail[action.payload.name] = action.payload.value;
            return newState;
        }

        case "UPDATE_SD_DROPDOWNS": {
            let newState = _.cloneDeep(state);
            if(action.payload.name !== null) {
                newState.sourceObject.source_detail[action.payload.change_obj.name] = action.payload.name.value;
            } else {
                newState.sourceObject.source_detail[action.payload.change_obj.name] = ""
            }
            return newState;
        }

        case addEditDPSourceActionTypes.TOGGLE_CONSENT_VALUE: {
            let newState = _.cloneDeep(state);
            if ( action.payload != null ) {
                newState.sourceObject.source_detail[action.payload] = !newState.sourceObject.source_detail[action.payload];
            } else {
                newState.sourceObject.source_detail[action.payload] = false;
            }
            return newState;
        }

        case "UPDATE_NOTES": {
            let newState = _.cloneDeep(state);
            newState.sourceObject.notes.forEach(note => {
                if (note.type === action.payload.name) {
                    note.note = action.payload.value
                }
            });
            return newState;
        }

        case addEditDPSourceActionTypes.SETTING_ASSOCIATED_SERVICE_OPTION: {
            let newState = _.cloneDeep(state);
            if ( action.payload.service != null ) {
                newState.sourceObject.service = action.payload.service;
                newState.sourceObject.source_detail.service_id = action.payload.service.service_id;
            } else {
                newState.sourceObject.service = {};
                newState.sourceObject.source_detail.service_id = "";
            }
            return newState;
        }

        case addEditDPSourceActionTypes.SETTING_ASSOCIATED_COUNTRY_OPTION: {
            let newState = _.cloneDeep(state);
            if ( action.payload.country != null ) {
                newState.sourceObject.source_detail.country = action.payload.country.id;
                newState.sourceObject.country = action.payload.country;
            } else {
                newState.sourceObject.country = {};
                newState.sourceObject.source_detail.country = "";
            }
            return newState;
        }

        case addEditDPSourceActionTypes.ADDING_VERIFIABLE_INPUT: {
            let newState = _.cloneDeep(state);
            let ids = new Set(newState.sourceObject.verifiable_inputs.map(d => d.label_id));
            const newInputsArr = action.payload;
            // efficiently remove possible dupe elements added by the user.
            newState.sourceObject.verifiable_inputs = [
                ...newState.sourceObject.verifiable_inputs,
                ...newInputsArr.filter(d => !ids.has(d.label_id))
            ];
            return newState;
        }

        case "UPDATE_RESULT_TYPE":{
            let newState = _.cloneDeep(state);
            newState.sourceObject.verifiable_inputs.forEach(vi =>{
                if (vi.id === action.payload.value) {
                    vi.scores = action.payload.change_obj === "scores"
                    vi.candidate_records = action.payload.change_obj === "candidate_records"
                }
            })
            return newState;
        }

        case addEditDPSourceActionTypes.DELETING_VERIFIABLE_INPUT: {
            let newState = _.cloneDeep(state);
            const toDelete = new Set([action.payload.value]);
            newState.toDelete.verifiable_inputs.push(action.payload.value)
            newState.sourceObject.verifiable_inputs = newState.sourceObject.verifiable_inputs.filter(
                obj => !toDelete.has(obj.id));
            return newState;
        }

        default:
            return state;
    }
}

export default addEditDPSourcesReducer;
